import { createSelector } from 'reselect'

export const bookingSelector = (state) => state.booking

export const bookingDataSelector = createSelector(
  bookingSelector,
  ({ bookingData }) => bookingData.data
)

export const bookingDataLoadingSelector = createSelector(
  bookingSelector,
  ({ bookingData }) => bookingData.loading
)

export const bookingDataErrorSelector = createSelector(
  bookingSelector,
  ({ bookingData }) => bookingData.error
)
export const bookAppointmentStatusSelector = createSelector(
  bookingSelector,
  ({ bookAppointment }) => bookAppointment.isBooked
)

export const bookApppointmentLoadingSelector = createSelector(
  bookingSelector,
  ({ bookAppointment }) => bookAppointment.loading
)

export const bookAppointmentErrorSelector = createSelector(
  bookingSelector,
  ({ bookAppointment }) => bookAppointment.error
)
